export default __webpack_public_path__ + "static/media/compass.788f6fc6.svg";